import _ from 'lodash'

export const roleManagement = (selectedRole) => {
    if(localStorage.getItem("roles") === null) return false
    if(!selectedRole) return true
   
    const roleArr = JSON.parse(atob(localStorage.getItem("roles")))
    const allRoles = roleArr.UserRoles.concat(roleArr.SpecialRoles)

    if (allRoles.includes(selectedRole)) {
        return true
    } else {
        return false
    }
}


export const sidebarRoleManagement = (selectedRoles) => {
    if (localStorage.getItem("roles") === null) return false
    if (selectedRoles?.length === 0) {
        return true
    }
    const roleArrs = JSON.parse(atob(localStorage.getItem("roles")))
    const allRoles = roleArrs.UserRoles.concat(roleArrs.SpecialRoles)

    if (_.intersection(allRoles, selectedRoles)?.length !== 0) {
        return true
    } else {
        return false
    }
}



// const safeJSONParse = (str) => {
//   try {
//     return JSON.parse(str);
//   } catch (error) {
//     console.error('JSON parsing error:', error);
//     return { UserRoles: [], SpecialRoles: [] };
//   }
// };

// const getRolesFromStorage = () => {
//   try {
//     const rolesString = localStorage.getItem("roles");
//     if (!rolesString) {
//       return { UserRoles: [], SpecialRoles: [] };
//     }

//     const decodedRoles = atob(rolesString);
//     // Handle potential encoding issues by replacing invalid characters
//     const sanitizedRoles = decodedRoles.replace(/[^\x20-\x7E]/g, '');
//     return safeJSONParse(sanitizedRoles);
//   } catch (error) {
//     console.error('Error retrieving roles:', error);
//     return { UserRoles: [], SpecialRoles: [] };
//   }
// };

// export const roleManagement = (selectedRole) => {
//   if (!selectedRole) return false;
  
//   const roleArr = getRolesFromStorage();
//   const allRoles = [...(roleArr.UserRoles || []), ...(roleArr.SpecialRoles || [])];
  
//   return allRoles.includes(selectedRole);
// };

// export const sidebarRoleManagement = (selectedRoles) => {
//   if (!selectedRoles || selectedRoles.length === 0) {
//     return true;
//   }
  
//   const roleArrs = getRolesFromStorage();
//   const allRoles = [...(roleArrs.UserRoles || []), ...(roleArrs.SpecialRoles || [])];
  
//   return _.intersection(allRoles, selectedRoles).length > 0;
// };